import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { ApplicationService, RolesService } from '../../services';
interface IApplicationNewModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-application-new-modal',
  templateUrl: './application-new-modal.component.html',
  styleUrls: ['./application-new-modal.component.scss'],
})
export class ApplicationNewModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  accessTypes = [
    { key: 'ALL', value: 'ALL - Available to all users' },
    {
      key: 'PROTECTED',
      value: 'PROTECTED - Available only to System admin by default ',
    },
    {
      key: 'COMPANY_ALL',
      value: 'COMPANY_ALL - Available to all contractors by default',
    },
    {
      key: 'COMPANY_ADMIN',
      value:
        'COMPANY_ADMIN - Available to System admin and Contractor Admin by default',
    },
    {
      key: 'DEPARTMENT_ADMIN',
      value:
        'DEPARTMENT_ADMIN - Available to System admin and all Department Admins by default',
    },
    {
      key: 'DEPARTMENT_ALL',
      value:
        'DEPARTMENT_ALL - Available to all NCC users excluding contractors of course by default;',
    },
  ];
  applicationForm: FormGroup;
  application;
  roles: Array<any> = [];
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private roleSvc: RolesService,
    public modal: SuiModal<IApplicationNewModalContext, void, void>,
    private applicationSvc: ApplicationService
  ) {
    this.applicationForm = fb.group({
      applicationName: ['', [Validators.required]],
      applicationId: ['', [Validators.required]],
      applicationHost: ['', [Validators.required]],
      applicationDescription: [''],
      ordering: [''],
      paymentCallBackUrl: [''],
      defaultUserRoles: [''],
      accessTypes: [[], [Validators.required]],
      hideFromDashboard: [false],
    });
    if (this.modal.context.isEdit) {
      this.application = modal.context.data;
      this.applicationForm.patchValue(modal.context.data);
    }
    this.getRoles();
  }
  isFieldValid(field: string) {
    return (
      (!this.applicationForm.get(field).valid &&
        this.applicationForm.get(field).touched) ||
      (this.applicationForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  getRoles() {
    this.roleSvc
      .getRoles({ params: { rows: 3000, sidx: 'roleId', sord: 'desc' } })
      .subscribe(
        (res: any) => {
          this.roles = res['rows'];
        },
        (error) => {}
      );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  submit() {
    if (this.applicationForm.valid) {
      this.modal.context.isEdit == true ? this.update() : this.save();
    }
  }
  update() {
    let data;
    if (typeof this.applicationForm.value.defaultUserRoles === 'object') {
      data = this.applicationForm.value.defaultUserRoles;
    } else {
      data = this.applicationForm.value.defaultUserRoles.split(',');
    }
    this.applicationForm.value.defaultUserRoles = data;
    this.success = null;
    this.error = null;
    this.pending = true;
    const self = this;
    let user = JSON.parse(window.localStorage.getItem('user'));

    this.applicationSvc
      .editApplication({
        applicationId: this.application.applicationId,
        body: { ...this.application, ...this.applicationForm.value },
      })
      .subscribe(
        (res) => {
          let targetId = this.application.applicationId;
          let indexToUpdate = user.applications.findIndex(
            (obj) => obj.applicationId === targetId
          );
          if (indexToUpdate !== -1) {
            user.applications[indexToUpdate].ordering =
              this.applicationForm.value.ordering;
            window.localStorage.setItem('user', JSON.stringify(user));
          } else {
            console.log('Object with ID', targetId, 'not found.');
          }
          this.pending = false;
          this.success = 'Application edited  successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }

  save() {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.applicationSvc
      .addApplication({ body: this.applicationForm.value })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.success = 'Application created  successfully';
          setTimeout(() => {
            this.modal.approve(res);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
  data = [
    {
      gender: 'male',
      lastName: 'praise',
      firstName: 'testing',
      middleName: 'bukunmi',
      shareholding: 0,
      nationalityId: 'DZ',
      nationalIdNumber: '1234566',
      countryOfOriginId: 'DZ',
      ownershipTypeName: null,
      ownershipTypeIdName: [{ 'company secretary_type': 'Company Secretary' }],
      photographDocumentId: '777f0a85-98f0-4b2e-b543-fb74bb23f384',
      photographDocumentPath:
        '2024-01/files/c04nn7OWfO______f070dc4f-9bbf-4187-9343-c0a0937dcc66Recovery_code.png',
      organizationOwnershipId: 'b6518d5a-aa8a-45e5-abc5-c9811b3fe760',
      organizationOwnershipTypeId: null,
    },
    {
      gender: 'male',
      lastName: 'ok',
      firstName: 'OK',
      middleName: 'okk',
      shareholding: 0,
      nationalityId: 'BY',
      nationalIdNumber: '4040049',
      countryOfOriginId: 'BY',
      ownershipTypeName: null,
      ownershipTypeIdName: [{ 'company secretary_type': 'Company Secretary' }],
      photographDocumentId: '1f8eb995-7546-4859-b6cb-ea9736be41d6',
      photographDocumentPath:
        '2024-01/files/wN1lJL1598______5269a6e5-425d-4b60-a5ba-44109772380bimage__7_.png',
      organizationOwnershipId: '3ce26b7b-3fe8-4c40-96d8-b82b1a6ffd1a',
      organizationOwnershipTypeId: null,
    },
    {
      gender: 'female',
      lastName: 'Eni',
      firstName: 'Ayo',
      middleName: 'Ayo',
      shareholding: 0,
      nationalityId: 'BZ',
      nationalIdNumber: '80888',
      countryOfOriginId: 'BZ',
      ownershipTypeName: null,
      ownershipTypeIdName: [{ 'company secretary_type': 'Company Secretary' }],
      photographDocumentId: 'df9aa9d8-2a9b-4257-a1fa-e7d289fa5960',
      photographDocumentPath:
        '2024-01/files/8KKHsGy7Vj______0db88bfd-8d31-4cd8-b2ae-d9dd5c8ce9adimage__7_.png',
      organizationOwnershipId: '19a6ef20-bdb1-402e-b01e-eabaaed23626',
      organizationOwnershipTypeId: null,
    },
    {
      gender: 'female',
      lastName: ' Uyi',
      firstName: 'Etinosa',
      middleName: '',
      shareholding: 0,
      nationalityId: 'AT',
      nationalIdNumber: '2034321',
      countryOfOriginId: 'AT',
      ownershipTypeName: null,
      ownershipTypeIdName: [{ 'company secretary_type': 'Company Secretary' }],
      photographDocumentId: '755bba5b-fce2-435d-8291-f1f1e53264f4',
      photographDocumentPath:
        '2023-10/files/vltOfVav5H______istockphoto-1189302444-612x612.jpg',
      organizationOwnershipId: '6411e947-b2a1-4ee6-8f67-493c1cfc0ffa',
      organizationOwnershipTypeId: null,
    },
    {
      gender: 'male',
      lastName: 'Two',
      firstName: 'One',
      middleName: 'Three',
      shareholding: 0,
      nationalityId: 'AZ',
      nationalIdNumber: '44444',
      countryOfOriginId: 'AQ',
      ownershipTypeName: null,
      ownershipTypeIdName: [{ 'company secretary_type': 'Company Secretary' }],
      photographDocumentId: 'b1d86043-8834-4c13-83e5-135c04d39720',
      photographDocumentPath:
        '2023-10/files/IKQWyUbq9l______istockphoto-1189302444-612x612.jpg',
      organizationOwnershipId: 'ae794725-1dee-44c4-ab75-66331fef7981',
      organizationOwnershipTypeId: null,
    },
  ];
}

export class ApplicationNewModal extends ComponentModalConfig<
  IApplicationNewModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Small
  ) {
    super(ApplicationNewModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
